import { ThemeProvider } from '@material-ui/styles';
import React from 'react';

import createCustomTheme from '@/components/shared/components/ThemeManager/createCustomTheme';
import { Theme } from '@/config/types';

interface ThemerProps {
  children: React.ReactNode;
  theme: Partial<Theme>;
}

function Themer(props: ThemerProps) {
  const { children, theme } = props;

  return <ThemeProvider theme={createCustomTheme(theme)}>{children}</ThemeProvider>;
}

export default React.memo(Themer);
